export default (state, action) => {
  return Object.assign({}, state, {
    data: {
      ...state.data,
    },
    open: action.payload,
    loading: false,
  });
};
